import { render, staticRenderFns } from "./KEditor.vue?vue&type=template&id=63b7dd85&scoped=true"
import script from "./KEditor.vue?vue&type=script&lang=js"
export * from "./KEditor.vue?vue&type=script&lang=js"
import style0 from "./KEditor.vue?vue&type=style&index=0&id=63b7dd85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7dd85",
  null
  
)

export default component.exports